module.exports = __webpack_public_path__ + "static/media/side-bar-icon.902cb748.svg";